import { getWithAuth } from '../../api';
import { loadGoogleMaps } from '../../utils/loadGoogleMaps';
import { baseMaps as googleBaseMaps, initializeLayers } from './GoogleLayers';
/**
 * Use mapTilerLayers for dev, Google for test/prod and Google + others for on-prem.
 */
// import { baseMaps as defaultBaseMaps } from './mapTilerLayers';
import { baseMaps as defaultBaseMaps } from './GoogleLayers';
import { createCustomBaseMaps } from './runtimeCustomLayers';
import { createOsmBaseMaps } from './runtimeOsmLayers';

export const baseMaps = {};

let initializationPromise = null;

function replaceBaseMaps(nextBaseMaps) {
  Object.keys(baseMaps).forEach((key) => {
    delete baseMaps[key];
  });
  Object.assign(baseMaps, nextBaseMaps);
  return baseMaps;
}

async function initializeGoogleBaseMaps() {
  await loadGoogleMaps();
  initializeLayers();
  return googleBaseMaps;
}

async function initializeOnPremGoogleBaseMaps(apiKey) {
  await loadGoogleMaps(apiKey);
  initializeLayers();
  return googleBaseMaps;
}

async function fetchOnPremMapConfig() {
  return await getWithAuth('config/map');
}

async function resolveRuntimeBaseMaps() {
  const onPrem = window.runtime?.onPremDist ?? false;
  if (!onPrem) {
    return window.runtime?.useGoogleMaps === true
      ? initializeGoogleBaseMaps()
      : defaultBaseMaps;
  }

  const config = await fetchOnPremMapConfig();
  if (config?.source === 'osm') {
    return createOsmBaseMaps(config?.osm_pmtiles_url);
  }

  if (config?.source === 'custom') {
    return createCustomBaseMaps(config?.custom_layers || []);
  }

  if (config?.source === 'dev') {
    return defaultBaseMaps;
  }

  return initializeOnPremGoogleBaseMaps(config?.google_tile_key || '');
}

export async function initializeMapProviders() {
  if (!initializationPromise) {
    initializationPromise = resolveRuntimeBaseMaps()
      .then((resolvedBaseMaps) => replaceBaseMaps(resolvedBaseMaps))
      .catch((error) => {
        console.error('Failed to resolve map providers:', error);
        const onPrem = window.runtime?.onPremDist ?? false;
        const fallbackBaseMaps = onPrem ? {} : defaultBaseMaps;
        return replaceBaseMaps(fallbackBaseMaps);
      });
  }

  return initializationPromise;
}
